<template>
    <div id="wrapper" >
      <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.report.label.title')}}</h4>
                            </div>
                        </div>
                    </div>
                       
                     <div class="row">
                        <div class="col-lg-12">
                            <div class="card-box">
                                <b-card no-body>
                                    <b-tabs  fill active-nav-item-class="text-uppercase">
                                        <b-tab active>
                                            <template v-slot:title>
                                                <i class="dripicons-parts"></i> <strong>{{'  '+ $t('string.msg.menu.register.expired.certified.label.title')}}</strong>
                                            </template>
                                            <ExpiredCertifie />
                                        </b-tab>
                                    
                                        <b-tab>
                                            <template v-slot:title>
                                                <i class="dripicons-service"></i> <strong>{{'  '+ $t('string.msg.menu.register.without.certified.label.title')}}</strong>
                                            </template>
                                            <WithoutCertifie />  
                                        </b-tab>    
                                    </b-tabs>
                                </b-card>
                            </div>
                        <!-- end card-box-->
                      </div>
                      <!-- end col -->
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
    </div>
</template>

<script>

import Controller from './CrtTruck';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import WithoutCertifie from './WithoutCertifie/WithoutCertifie.vue';
import ExpiredCertifie from './ExpiredCertifie/ExpiredCertifie.vue';

export default {
    name: 'Request',
    components: {
    Spinner,
    WithoutCertifie,
    ExpiredCertifie,
    Toast,
    },
    data() {
        return {
                errors: [],
                truckers:[],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this);
    },
    mounted() {
    }
    }
    </script>

    <style>
    </style>
